import LiveScoresDashboard from '../components/scores/LiveScoresDashboard'

export default function ScoresPage() {
  return <LiveScoresDashboard />
}
